
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('./../views/Home.vue'),
        meta:{
            auth : false,
            title : 'Home'
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('./../views/Login.vue'),
        meta: {
            auth: false,
            title: 'Login'
        }
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: () => import('./../views/ResetPassword.vue'),
        meta: {
            auth: false,
            title: 'Login'
        }
    },
    
        {
            path: '/patients-list',
            name: 'ListPatients',
            component: () => import('./../views/Patients/List.vue'),
            meta:{
                auth : true,
                title : 'Patients List'
            }
        },
        {
            path: '/patients_view-list',
            name: 'ListViewPatients',
            component: () => import('./../views/Patients/ListView.vue'),
            meta:{
                auth : true,
                title : 'Patients List'
            }
        },
            {
            path: '/patients-list/:id',
            name: 'ViewPatients',
            component: () => import('./../views/Patients/Edit.vue'),
            meta:{
                auth : true,
                title : 'Patients Edit'
            }
        },
        {
            path: '/record_tests-list',
            name: 'ListRecord_tests',
            component: () => import('./../views/Record_tests/List.vue'),
            meta:{
                auth : true,
                title : 'Record_tests List'
            }
        },
            {
            path: '/record_tests-list/:id',
            name: 'ViewRecord_tests',
            component: () => import('./../views/Record_tests/Edit.vue'),
            meta:{
                auth : true,
                title : 'Record_tests Edit'
            }
        },
        {
            path: '/records-list',
            name: 'ListRecords',
            component: () => import('./../views/Records/List.vue'),
            meta:{
                auth : true,
                title : 'Records List'
            }
        },
            {
            path: '/records-list/:id',
            name: 'ViewRecords',
            component: () => import('./../views/Records/Edit.vue'),
            meta:{
                auth : true,
                title : 'Records Edit'
            }
        },
            {
            path: '/records-list-main/:id',
            name: 'ViewRecords',
            component: () => import('./../views/Records/Editmain.vue'),
            meta:{
                auth : true,
                title : 'Records Edit Main'
            }
        },

        {
            path: '/tests-list',
            name: 'ListTests',
            component: () => import('./../views/Tests/List.vue'),
            meta:{
                auth : true,
                title : 'Tests List'
            }
        },
            {
            path: '/tests-list/:id',
            name: 'ViewTests',
            component: () => import('./../views/Tests/Edit.vue'),
            meta:{
                auth : true,
                title : 'Tests Edit'
            }
        },
        {
            path: '/units-list',
            name: 'ListUnits',
            component: () => import('./../views/Units/List.vue'),
            meta:{
                auth : true,
                title : 'Units List'
            }
        },
            {
            path: '/units-list/:id',
            name: 'ViewUnits',
            component: () => import('./../views/Units/Edit.vue'),
            meta:{
                auth : true,
                title : 'Units Edit'
            }
        },
        {
            path: '/options',
            name: 'Options',
            component: () => import('./../views/Options.vue'),
            meta:{
                auth : true,
                title : 'Options'
            }
        },
        {
            path: '/reports-list',
            name: 'ReportList',
            component: () => import('./../views/Reports/Report.vue'),
            meta:{
                auth : true,
                title : 'Reports List'
            }
        }
]
const router = new VueRouter({
    routes,
    mode:'history'
})

export default router
        